import { Spinner } from '@chakra-ui/react'

export default Spinner
